import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star-register",
  "use": "icon-star-register-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 20\" id=\"icon-star-register\"><path d=\"M9.505.969a1 1 0 0 1 1.816 0l2.243 4.863a1 1 0 0 0 .79.574l5.318.63a1 1 0 0 1 .562 1.728L16.302 12.4a1 1 0 0 0-.302.929l1.044 5.253a1 1 0 0 1-1.47 1.067l-4.673-2.616a1 1 0 0 0-.977 0L5.251 19.65a1 1 0 0 1-1.47-1.067l1.044-5.253a1 1 0 0 0-.301-.93L.592 8.765a1 1 0 0 1 .56-1.727l5.32-.631a1 1 0 0 0 .79-.574L9.504.969Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol